import { Box, useTheme } from "@mui/material";
import { sidebarWidth } from "../../layout/components/sidebar/sidebar";

import type { SxProps } from "@mui/material";
import type { FC, ReactNode } from "react";

export const FOOTER_HEIGHT = "4.5em";

export const FixedFooter: FC<{
  children: ReactNode;
  sx?: SxProps;
  noSidebar?: boolean;
  footerHeight?: string;
}> = ({ children, sx = [], noSidebar = false, footerHeight = FOOTER_HEIGHT }) => {
  const theme = useTheme();

  const actualSidebarWidth = noSidebar ? 0 : sidebarWidth;

  const width = {
    ...(actualSidebarWidth > 0
      ? { lg: `calc(100vw - ${actualSidebarWidth}px - ${theme.spacing(2)})` }
      : {}),
    sm: "100%",
  };

  return (
    <Box
      className="fixedFooter--root"
      sx={[
        () => ({
          position: "fixed",
          bottom: 0,
          right: 0,
          width,
          background: theme.palette.background.paper,
          boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
          zIndex: theme.zIndex.footer,
          height: footerHeight,
        }),
        ...(sx instanceof Array ? sx : [sx]),
      ]}
    >
      <Box
        className="fixedFooter--content"
        sx={{
          margin: `0 auto`,
          px: 4,
          maxWidth: "xl",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
